// extracted by mini-css-extract-plugin
module.exports = {"datagridBody":"DatagridBody_datagridBody__NhOD_"};